export default (state, getters, rootState, rootGetters) => val => {
    if (!rootGetters['dictionary/currency/getIso']) return '';
    return rootGetters['dictionary/currency/getIso'](val.currency);
}